// assets/cart.api.js
// Minimal, Dawn-friendly AJAX cart for Peora
window.Shopify = window.Shopify || {};

(function ($) {
  "use strict";

  //----------------------------------------------------
  // Money formatting (no dependency on api.jquery.js)
  //----------------------------------------------------
  // We won't rely on Shopify.money_format here because we want
  // proper Indian-style commas like ₹10,300 / ₹1,05,500
  function formatPrice(cents) {
    // Accept both number and string
    if (typeof cents === "string") {
      cents = parseInt(cents.replace(/[^\d]/g, ""), 10) || 0;
    }

    // Convert paise → rupees, rounded
    var rupees = Math.round(cents / 100);

    // Format with Indian digit grouping
    var formatted = rupees.toLocaleString("en-IN"); // 10300 -> "10,300"

    return "₹" + formatted;
  }

  //----------------------------------------------------
  // Core cart helpers
  //----------------------------------------------------
  Shopify.getCart = function (callback) {
    $.getJSON("/cart.js", function (cart) {
      if (typeof callback === "function") callback(cart);
      if (typeof Shopify.onCartUpdate === "function") Shopify.onCartUpdate(cart);
    });
  };

  Shopify.addItem = function (variantId, quantity, callback, properties) {
  quantity = quantity || 1;

  var addData = {
    id: variantId,
    quantity: quantity
  };

  var halfPriceVariantIds = (window.peoraHalfPriceVariantIds || []).map(function (id) {
    return String(id);
  });

  if (!properties && halfPriceVariantIds.indexOf(String(variantId)) > -1) {
    properties = {
      "_HalfPriceStore": "Yes"
    };
  }

  if (properties && typeof properties === "object") {
    addData.properties = properties;
  }

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: addData,
    dataType: "json",
    success: function (lineItem) {
      if (typeof callback === "function") {
        callback(lineItem);
      } else {
        Shopify.onItemAdded(lineItem);
      }
    },
    error: function (xhr) {
      Shopify.onError(xhr);
    }
  });
};

  Shopify.removeItem = function (variantId, callback) {
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: { ["updates[" + variantId + "]"]: 0 },
      dataType: "json",
      success: function (cart) {
        if (typeof callback === "function") callback(cart);
        if (typeof Shopify.onCartUpdate === "function") Shopify.onCartUpdate(cart);
      },
      error: function (xhr) {
        Shopify.onError(xhr);
      }
    });
  };

  // Change quantity by line number
  Shopify.changeItem = function (line, quantity, callback) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: { line: line, quantity: quantity },
      dataType: "json",
      success: function (cart) {
        if (typeof callback === "function") callback(cart);
        if (typeof Shopify.onCartUpdate === "function") Shopify.onCartUpdate(cart);
      },
      error: function (xhr) {
        Shopify.onError(xhr);
      }
    });
  };

  //----------------------------------------------------
  // Drawer open / close
  //----------------------------------------------------
  function openMiniCart() {
    var $wrap = $(".offcanvas-minicart-wrapper");
    if (!$wrap.length) return;

    var $inner = $wrap.find(".minicart-inner");
    $inner.addClass("show").removeClass("dontshow");
    $("body").addClass("fix");
  }

  function closeMiniCart() {
    var $wrap = $(".offcanvas-minicart-wrapper");
    if (!$wrap.length) return;

    var $inner = $wrap.find(".minicart-inner");
    $inner.removeClass("show dontshow");
    $("body").removeClass("fix");
  }

  Shopify.openMiniCart = openMiniCart;
  Shopify.closeMiniCart = closeMiniCart;

  //----------------------------------------------------
  // Callbacks
  //----------------------------------------------------
  Shopify.onItemAdded = function () {
    Shopify.getCart(function () {
      openMiniCart();
    });
  };

  Shopify.onCartUpdate = function (cart) {
    Shopify.cartUpdateInfo(cart, ".single-cart-item-loop");
  };

  Shopify.onError = function (xhr) {
    var message = "Error adding to cart.";
    try {
      var data = JSON.parse(xhr.responseText);
      if (data && data.description) message = data.description;
    } catch (e) {}
    console.error(message);
  };

  //----------------------------------------------------
  // Rebuild minicart HTML – card layout with qty pill
  //----------------------------------------------------
  Shopify.cartUpdateInfo = function (cart, cartCellSelector) {
    var $cell = $(cartCellSelector);

    if ($cell.length) {
      $cell.empty();

      if (cart.items && cart.items.length) {
        $(".minicart-content-box").show();
        $(".cart-empty-title").hide();

        $.each(cart.items, function (index, item) {
          if (index > 19) return false; // max 20 items

          var lineNumber = index + 1;
          var currentPrice = item.final_price || item.price;
          var comparePrice =
            item.original_price && item.original_price > currentPrice
              ? item.original_price
              : null;

          var productTitle = item.product_title || item.title || "";
          var variantTitle =
            item.variant_title && item.variant_title !== "Default Title"
              ? item.variant_title
              : "";

          var html =
            '<div class="minicart-item-card" data-variant-id="' +
            item.variant_id +
            '" data-line="' +
            lineNumber +
            '">' +
            '  <div class="minicart-thumb">' +
            '    <a href="' +
            item.url +
            '">' +
            '      <img src="' +
            (item.image || "") +
            '" alt="' +
            (item.title || "") +
            '">' +
            "    </a>" +
            "  </div>" +
            '  <div class="minicart-content">' +
            '    <div class="minicart-row-top">' +
            '      <div class="minicart-price-block">' +
            '        <span class="minicart-price-current">' +
            formatPrice(currentPrice) +
            "</span>";

          if (comparePrice) {
            html +=
              '        <span class="minicart-price-compare">' +
              formatPrice(comparePrice) +
              "</span>";
          }

          html +=
            "      </div>" +
            '      <button class="minicart-remove" type="button" onclick="Shopify.removeItem(' +
            item.variant_id +
            ')">' +
            '        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '          <path d="M14.9502 4.27979V5.05029H18.9502V5.94971H17.9502V18.3853C17.9501 18.8326 17.8008 19.2038 17.5029 19.5024C17.2049 19.8011 16.8327 19.9504 16.3838 19.9497H7.61621C7.18149 19.9497 6.81298 19.7977 6.50781 19.4927C6.20264 19.1875 6.04987 18.8193 6.0498 18.3853V5.94971H5.0498V5.05029H9.0498V4.27979H14.9502ZM6.9502 18.9995H7.0498V18.7495C7.07481 18.7894 7.10304 18.8281 7.1377 18.8628C7.23206 18.9571 7.34639 19.0153 7.47852 19.0386L7.61621 19.0503H16.3848C16.5537 19.0503 16.7076 18.9787 16.8438 18.8433C16.9459 18.7416 17.0111 18.6296 17.0371 18.5083L17.0498 18.3833V5.94971H6.9502V18.9995ZM14.1416 8.05029V16.9497H13.2422V8.05029H14.1416ZM10.7578 8.05029V16.9497H9.8584V8.05029H10.7578Z" fill="#4A2870" stroke="white" stroke-width="0.1"/>' +
            "        </svg>" +
            "      </button>" +
            "    </div>" +
            '    <h3 class="product-name"><a href="' +
            item.url +
            '">' +
            productTitle +
            "</a></h3>";

          if (variantTitle) {
            html += '<p class="minicart-meta">' + variantTitle + "</p>";
          }

          html +=
            '    <div class="minicart-qty-row">' +
            '      <div class="minicart-qty-control">' +
            '        <button type="button" class="qty-btn js-cart-qty-minus" data-line="' +
            lineNumber +
            '" data-variant-id="' +
            item.variant_id +
            '">−</button>' +
            '        <span class="qty-value js-cart-qty-value">' +
            item.quantity +
            "</span>" +
            '        <button type="button" class="qty-btn js-cart-qty-plus" data-line="' +
            lineNumber +
            '" data-variant-id="' +
            item.variant_id +
            '">+</button>' +
            "      </div>" +
            "    </div>" +
            "  </div>" +
            "</div>";

          $cell.append(html);
        });
      } else {
        $(".minicart-content-box").hide();
        $(".cart-empty-title").show();
      }
    }

    // totals + count
    $(".shopping-cart__total").html(formatPrice(cart.total_price));
    $(".bigcounter").html(cart.item_count);
  };

  //----------------------------------------------------
  // Bind open/close buttons + qty buttons
  //----------------------------------------------------
  $(function () {
    $(document).on("click", ".minicart-btn", function (e) {
      e.preventDefault();
      openMiniCart();
    });

    $(document).on("click", ".minicart-close, .offcanvas-overlay", function (e) {
      e.preventDefault();
      closeMiniCart();
    });

    // Quantity +/- controls
    $(document).on("click", ".js-cart-qty-plus, .js-cart-qty-minus", function (e) {
      e.preventDefault();
      var $btn = $(this);
      var line = parseInt($btn.data("line"), 10);
      var $wrap = $btn.closest(".minicart-qty-control");
      var $value = $wrap.find(".js-cart-qty-value");
      var current = parseInt($value.text(), 10) || 1;

      if ($btn.hasClass("js-cart-qty-plus")) {
        Shopify.changeItem(line, current + 1);
      } else {
        if (current <= 1) {
          var variantId =
            $btn.data("variant-id") ||
            $btn.closest(".minicart-item-card").data("variant-id");
          Shopify.removeItem(variantId);
        } else {
          Shopify.changeItem(line, current - 1);
        }
      }
    });
  });
})(jQuery);
